var _path, _rect, _path2, _rect2, _path3, _rect3, _polygon, _rect4, _polygon2, _rect5, _polygon3, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCodeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0v233.739h233.739V0H0z M200.348,200.348H33.391V33.391h166.957V200.348z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.783,
    y: 66.783,
    width: 100.174,
    height: 100.174
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278.261,0v233.739H512V0H278.261z M478.609,200.348H311.652V33.391h166.957V200.348z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 345.043,
    y: 66.783,
    width: 100.174,
    height: 100.174
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,278.261V512h233.739V278.261H0z M200.348,478.609H33.391V311.652h166.957V478.609z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66.783,
    y: 345.043,
    width: 100.174,
    height: 100.174
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "278.261,278.261 278.261,512 345.043,512 345.043,478.609 311.652,478.609 311.652,411.826 345.043,411.826  345.043,378.435 311.652,378.435 311.652,311.652 345.043,311.652 345.043,278.261 "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 478.609,
    y: 278.261,
    width: 33.391,
    height: 33.391
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "478.609,478.609 445.217,478.609 445.217,512 512,512 512,356.174 478.609,356.174 "
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 378.435,
    y: 278.261,
    width: 66.783,
    height: 33.391
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "445.217,411.826 411.826,411.826 411.826,378.435 445.217,378.435 445.217,345.043 378.435,345.043  378.435,445.217 445.217,445.217 "
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 378.435,
    y: 478.609,
    width: 33.391,
    height: 33.391
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeIcon);
export default __webpack_public_path__ + "static/media/qr-code-icon.0a49262814ae42644d7303e5ef5b7e3d.svg";
export { ForwardRef as ReactComponent };